import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import StoreApplicationState from "@store/Store/StoreApplicationState";

export const selector = (state: StoreApplicationState) => {
    return getCurrentPage(state);
};
